<template>
  <InfoCards v-bind="{ heading: { title, label, subtitle }, items: quartered }" />
</template>

<script>
import InfoCards from '@/sections/info-cards/InfoCards.vue'

export default {
  components: {
    InfoCards
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    quartered() {
      let groups = []
      let items = []
      this.items.forEach((item, i) => {
        items.push(item)
        if (i !== 0 && (i + 1) % 4 === 0) {
          groups.push(items)
          items = []
        } else if (i == this.items.length - 1) {
          groups.push(items)
        }
      })
      return groups
    }
  },
}
</script>

<docs>
  ```vue
  <InfoCards card-type="link" label="Label" title="Title" :info="[{ icon: 'destination', text: 'Text' }, { icon: 'chat', text: 'Text' }, { icon: 'edit', text: 'Text' }, { icon: 'destination', text: 'Text' }, { icon: 'destination', text: 'Text' }]" />
  ```
</docs>
